import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRight, Trophy, GraduationCap, Shirt } from 'lucide-react';
export function SchoolsTeamsPage() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-627">
      <Header data-id="element-628" />

      <main className="flex-grow" data-id="element-629">
        {/* Hero */}
        <section className="bg-gradient-to-br from-blue-700 to-blue-900 text-white py-20 md:py-32" data-id="element-630">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-631">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-632">
              Schools & Teams Headquarters
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-10" data-id="element-633">
              The easiest way to outfit your players, students, and fans. We
              handle everything from design to production and even online team
              stores.
            </p>
            <a href="/contact" className="inline-flex items-center px-8 py-4 bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold rounded-full shadow-lg transition-all transform hover:-translate-y-1" data-id="element-634">
              Get Team Quote
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-635" />
            </a>
          </div>
        </section>

        {/* Benefits */}
        <section className="py-20" data-id="element-636">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-637">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-638">
              <div className="p-6" data-id="element-639">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-640">
                  <Trophy className="h-8 w-8 text-blue-600" data-id="element-641" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-642">Uniforms & Jerseys</h3>
                <p className="text-gray-600" data-id="element-643">
                  High-performance gear that looks pro and stands up to the
                  game. Numbering and personalization available.
                </p>
              </div>
              <div className="p-6" data-id="element-644">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-645">
                  <GraduationCap className="h-8 w-8 text-blue-600" data-id="element-646" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-647">Spirit Wear</h3>
                <p className="text-gray-600" data-id="element-648">
                  Hoodies, tees, and accessories for students, parents, and
                  faculty to show their school pride.
                </p>
              </div>
              <div className="p-6" data-id="element-649">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-650">
                  <Shirt className="h-8 w-8 text-blue-600" data-id="element-651" />
                </div>
                <h3 className="text-xl font-bold mb-3" data-id="element-652">Online Team Stores</h3>
                <p className="text-gray-600" data-id="element-653">
                  Stop collecting paper order forms. We build a custom online
                  store for your team to order directly.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonial */}
        <section className="bg-gray-50 py-20" data-id="element-654">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-655">
            <div className="mb-8" data-id="element-656">
              <div className="flex justify-center mb-4" data-id="element-657">
                {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-6 h-6 text-yellow-400 fill-current" viewBox="0 0 24 24" data-id="element-658">
                    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-659" />
                  </svg>)}
              </div>
              <blockquote className="text-2xl font-medium text-gray-900 italic mb-6" data-id="element-660">
                "No matter what life throws at me teams and tees have been able
                to make shirts business cards, cups, hats and even see something
                on for my fiancé dress whites. If you have a problem with them
                you have a problem with me."
              </blockquote>
              <cite className="text-gray-600 font-semibold not-italic" data-id="element-661">
                - Brianna S.
              </cite>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-662" />
    </div>;
}